import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Dropdown from '../components/Dropdown';
import { languages, fetchTranslations, LANG_PREFERENCE, setDeviceLanguage, handleLanguageChange } from '../state/actions/locale';
import { isDevice } from '../utils/mobile';
import { localize } from '../i18n';

export class LanguageDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
      requestLanguage: 'close',
    };
  }

  render() {
    const langOptions = languages;

    const langItems = langOptions.filter(item => item.isEnabled).map(item => (
      <li
        key={item.code}
        className={`${item.code === this.props.lang ? 'uk-active' : ''}`}
      >
        <a
          href=""
          className="uk-list-item"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ requestLanguage: 'close' });
            const lang = item.code;
            const isFetch = !(lang === 'en' || this.props.translations[lang]);
            if (isFetch) {
              const { dispatch } = this.props;
              dispatch(fetchTranslations(lang, true, this.props.setTranslations, this.props.setLanguage));
            } else {
              handleLanguageChange(lang);
              this.props.setLanguage(lang);
              if (isDevice()) {
                setDeviceLanguage(lang);
                window.localStorage.setItem(LANG_PREFERENCE, lang);
              }
            }
          }}
        >
          {item.title}
        </a>
      </li>
    ));

    const currentLangObj = _.find(langOptions, { code: this.props.lang });

    return (
      <Dropdown
        href="#filter-dropdown"
        label={[
          <span key="1" className="dropdown-label">{currentLangObj.title}</span>,
          <i className="material-icons" key="2">&#xE313;</i>,
        ]}
        request={this.state.requestLanguage}
        onChange={(changeRequest) => {
          this.setState({
            requestLanguage: changeRequest === true ? 'open' : 'close',
          });
        }}
        wrapperClassName="uk-button-dropdown"
        className="md-btn md-btn-flat md-btn-small md-btn-wave waves-effect waves-button language-dropdown"
      >
        <ul className="uk-nav uk-nav-dropdown">{langItems}</ul>
      </Dropdown>
    );
  }
}

LanguageDropdown.propTypes = {
  lang: PropTypes.string,
  translations: PropTypes.shape({}).isRequired,
  setLanguage: PropTypes.func.isRequired,
  setTranslations: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
};

export default localize(connect()(LanguageDropdown));



// WEBPACK FOOTER //
// ./src/containers/LanguageDropdown.js